import React from 'react';

import styled from '@emotion/styled';

import FeedbackAnalysisChart from './FeedbackAnalysisChart';
import FeedbackAnalysisTable from './FeedbackAnalysisTable';

const FeedbackAnalysis = () => {
  return (
    <Container>
      <FeedbackAnalysisChart />
      <FeedbackAnalysisTable />
    </Container>
  );
};

export default FeedbackAnalysis;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;
